import {imageWebFromImageWebSchema} from '@/modules/foundation/sanity/image/query';

import type {Person} from '../shared/types';

import type {PersonListSelectionFragment} from './person-list-selection-container/query';

export const PERSON_IN_CARD_FRAGMENT = `//groq
	...,
`;

export type PersonInCardFragment = NonNullable<PersonListSelectionFragment['persons']>[number];

export const personFromPersonInCardFragment = (personInCard: PersonInCardFragment): Person => {
	return {
		name: personInCard?.name ?? '',
		image: personInCard?.image?.asset?._ref
			? imageWebFromImageWebSchema(personInCard.image, 1)
			: undefined,
		phone: personInCard?.phone,
		email: personInCard?.email,
		role: personInCard?.role,
		company: personInCard?.company,
		departmentManager: personInCard?.departmentManager ?? false,
	};
};
